import { useState } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { BiSearch } from "react-icons/bi";

import { Tooltip, TooltipContent, TooltipTrigger, useBreakpoints } from "@sorcery/ui";

import { SearchAllBox } from "~/components/organisms/SearchAllBox";
import { ModalTypeEnum, useModal } from "~/providers/ModalProvider";

export const Search = () => {
  const [focus, setFocus] = useState(false);
  // https://github.com/JohannesKlauss/react-hotkeys-hook
  useHotkeys("ctrl+/", () => setFocus(true), []);
  useHotkeys("esc", () => setFocus(false), { enableOnFormTags: ["input"] });
  const { isXl } = useBreakpoints();
  const { openModal } = useModal();

  return (
    <div className="group/search px-1">
      {focus ? (
        <div
          className="mt-1 max-w-[14rem] duration-700 animate-in fade-in xl:max-w-[20rem]"
          onBlur={() => setTimeout(() => setFocus(false), 150)}
        >
          <SearchAllBox />
        </div>
      ) : (
        <Tooltip>
          <TooltipTrigger
            onClick={() => {
              if (!isXl) {
                openModal(ModalTypeEnum.SEARCH);
              } else {
                setFocus(true);
              }
            }}
          >
            <BiSearch
              className={"mt-2 transition duration-150 ease-in-out group-hover/search:opacity-60"}
              size={15}
            />
          </TooltipTrigger>
          <TooltipContent>
            <p>Search (ctrl+/)</p>
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
};
